import Component from "@glimmer/component";
import ENV from "glesys-controlpanel/config/environment";
import { keepLatestTask } from "ember-concurrency";
import { service } from "@ember/service";
import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";
import DataLoader from "glesys-controlpanel/components/data-loader";
import IconsLoadingSpinner from "glesys-controlpanel/components/icons/loading-spinner";
import Cost from "glesys-controlpanel/components/cost";
import InfoPopup from "glesys-controlpanel/components/info-popup";
import { t } from "ember-intl";
import gMibToGib from "glesys-controlpanel/helpers/g-mibtogib";

export default class extends Component {
  @service ajax;
  @service abilities;

  get config() {
    return this.args.config;
  }

  get project() {
    return this.args.project;
  }

  get hasResellerPricing() {
    return this.abilities.cannot("access pricing for organization", this.project?.organization);
  }

  getServerCostTask = keepLatestTask(async () => {
    if (this.hasResellerPricing) {
      return;
    }

    let projectId = this.project?.id;
    let url = `${ENV.apiBaseUri}/server/estimatedcost`;

    let data = {
      projectkey: projectId,
      ...this.config,
      numberofbackupimagestokeep: 0,
    };

    try {
      let response = await this.ajax.post(url, { data });

      return response.billing;
    } catch {
      return { price: null };
    }
  });

  <template>
    <div class="flex items-center flex-col flex-wrap" data-test-appliance-cost {{mergeClasses}} ...attributes>
      <DataLoader @load={{this.getServerCostTask}}>
        <:loading>
          <IconsLoadingSpinner class="w-8 mb-3" />
        </:loading>
        <:default as |cost|>
          <Cost @currency={{this.project.currency}} @price={{cost.price}} @discountedPrice={{cost.total}} />
        </:default>
      </DataLoader>
      <p class="w-full text-center mt-4 text-sm text-gray-800">
        <span class="flex items-center justify-center">
          <span class="pr-1">{{t "appliance.create.cost-for-ip"}}</span>
          {{#unless this.hasResellerPricing}}
            <InfoPopup data-test-appliance-cost-popup>{{t "appliance.create.tooltip-excluding"}}</InfoPopup>
          {{/unless}}
        </span>
        {{t
          "appliance.create.basic-configuration"
          cpu=this.config.cpucores
          memory=(gMibToGib this.config.memorysize)
          disk=this.config.disksize
          bandwidth=this.config.bandwidth
        }}
      </p>
    </div>
  </template>
}
